import getConfig from './get-config';

type QueryCodeEntry = { queryCode: string; dsConfig: string; config: string };

function generateQueryCodes(): QueryCodeEntry[] {
    const periods = ['anl', 'san', 'l12', 'qtr', 'ytd'];
    const queryNameSuffixes = ['adi'];
    const configCodes = getConfig('components.queryBuilder.queryCodes') as QueryCodeEntry[];
    const generated = periods.flatMap((period: string) => queryNameSuffixes.map((queryNameSuffix: string) => ({
        queryCode: `cm_fin_lf_all_${period}_${queryNameSuffix}`,
        dsConfig: 'config_ts',
        config: 'config_ci_cf'
    })));
    return [...configCodes, ...generated];
}

export default generateQueryCodes;
